import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  configurationSettingDetail,
  configurationSettingUpdate,
} from "reduxStore/action/configurationSettingAction";
import strings from "translate/language";
import { emailAddressValid, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";

const ConfigurationEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModify, setIsModify] = useState(true);
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const configurationSettingDetailSelector =
    useSelector((state) => state?.configurationSettingDetail) || [];
  useEffect(() => {
    dispatch(configurationSettingDetail({ type: "email" }));
  }, []);

  useEffect(() => {
    if (configurationSettingDetailSelector.detail === true) {
      if (configurationSettingDetailSelector?.response?.status === 200) {
        setForm({
          ...form,
          _id: configurationSettingDetailSelector.response.data._id,
          email: configurationSettingDetailSelector.response.data.email,
          smtp_key: configurationSettingDetailSelector.response.data.smtp_key,
          smtp_user_id:
            configurationSettingDetailSelector.response.data.smtp_user_id,
          smtp_password:
            configurationSettingDetailSelector.response.data.smtp_password,
        });
      }
    }
  }, [configurationSettingDetailSelector]);

  const handleUpdate = () => {
    if (!handleValid()) {
      const post = {
        setting_id: form._id,
        email: form.email,
        smtp_key: form.smtp_key,
        smtp_user_id: form.smtp_user_id,
        smtp_password: form.smtp_password,
      };
      setIsModify(true);
      dispatch(configurationSettingUpdate(post));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.email) {
      formError = true;
      err["email"] = strings.emailErr;
    } else if (!emailAddressValid(form.email)) {
      formError = true;
      err["email"] = strings.emailValidationErr;
    }
    if (!form.smtp_key) {
      formError = true;
      err["smtp_key"] = strings.smtpKey_Err;
    }
    if (!form.smtp_user_id) {
      formError = true;
      err["smtp_user_id"] = strings.smtpuserId_Err;
    }
    if (!form.smtp_password) {
      formError = true;
      err["smtp_password"] = strings.smtpPassword_Err;
    }
    setFormVaild(err);
    return formError;
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  useEffect(() => {
    seo({
      title: "Email",
      metaDescription: "Configuration Email",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.configurationSetting}
        titleactive={strings.configurationEmail}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.configurationEmail}</h5>
              </div>
              <div className="card-body">
                <form>
                  <fieldset disabled={isModify}>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.email}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="email"
                            autoComplete="off"
                            onChange={handleInputField}
                            value={form.email}
                          />
                          {formVaild.email && (
                            <span style={{ color: "red" }}>
                              {formVaild.email}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.smtpKey}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="smtp_key"
                            autoComplete="off"
                            onChange={handleInputField}
                            value={form.smtp_key}
                          />
                          {formVaild.smtp_key && (
                            <span style={{ color: "red" }}>
                              {formVaild.smtp_key}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlEmail">
                            {strings.smtpUserId}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlEmail"
                            type="text"
                            name="smtp_user_id"
                            autoComplete="off"
                            onChange={handleInputField}
                            value={form.smtp_user_id}
                          />
                          {formVaild.smtp_user_id && (
                            <span style={{ color: "red" }}>
                              {formVaild.smtp_user_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlPass">
                            {strings.password}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlPass"
                            type="text"
                            name="smtp_password"
                            autoComplete="off"
                            onChange={handleInputField}
                            value={form.smtp_password}
                          />
                          {formVaild.smtp_password && (
                            <span style={{ color: "red" }}>
                              {formVaild.smtp_password}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <Button
                          className="btn btn-color mr-5"
                          onClick={() => setIsModify(!isModify)}
                          label={strings.modify}
                        ></Button>
                        <Button
                          className="btn btn-color"
                          disabled={isModify}
                          onClick={() => handleUpdate()}
                          label={strings.update}
                        ></Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfigurationEmail;
